import script from "./CategoriesImportView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesImportView.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesImportView.vue?vue&type=style&index=0&id=3d1ab1be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1ab1be"]])

export default __exports__